<template>
  <div v-show="show" class="context-menu" :style="{ top: top + 'px', left: left + 'px' }">
    <ul class="menu-list">
      <li v-for="(item, index) in items" :key="index">
        <a @click="itemClicked(item)">
          <span class="icon is-small" v-if="item.icon">
            <i :class="item.icon"></i>
          </span>
          <span>{{ item.label }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ContextMenu',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      show: false,
      top: 0,
      left: 0
    };
  },
  methods: {
    open(event) {
      this.show = true;
      this.top = event.clientY;
      this.left = event.clientX;
      this.$nextTick(() => {
        this.$el.focus();
      });
    },
    close() {
      this.show = false;
    },
    itemClicked(item) {
      this.$emit('item-click', item);
      this.close();
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/dark-variables.scss';

.context-menu {
  position: fixed;
  z-index: 1000;
  min-width: 13rem;
  background: rgba(15, 23, 36, 0.96);
  border: 1px solid rgba(190, 214, 238, 0.16);
  border-radius: 8px;
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.32);
  padding: 0.35rem;
  backdrop-filter: blur(12px);

  .menu-list a {
    color: $dark-text-secondary;
    padding: 0.56rem 0.7rem;
    display: flex;
    align-items: center;
    gap: 0.55rem;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    transition: background-color 0.16s ease, color 0.16s ease;

    &:hover {
      background-color: rgba($primary, 0.12);
      color: $dark-text-primary;
    }

    .icon {
      margin-right: 0;
      color: $primary;
    }
  }
}
</style>
